import {Group, GroupCreate, GroupResults} from "../schemas";
import {apiFetch} from "./client";

export async function createGroup(groupData: GroupCreate): Promise<Group> {
    return apiFetch<Group>("/groups", {method: "POST", body: groupData});
}

export async function clearGroupWorkspace(groupId: string): Promise<boolean> {
    const resp = await apiFetch<{ success: boolean }>("/groups/clear_workspace", {
        method: "DELETE",
        params: {group_id: groupId},
    });
    return resp.success;
}

export async function getGroups(ids?: string[]): Promise<Group[]> {
    const resp = await apiFetch<GroupResults>("/groups/get_groups", {
        params: ids ? {ids} : undefined,
    });
    return resp.groups;
}

export async function updateGroup(groupId: string, name: string): Promise<Group> {
    return apiFetch<Group>(`/groups/${groupId}`, {
        method: "PUT",
        body: {id: groupId, name},
    });
}

export async function deleteGroup(groupId: string): Promise<Group> {
    return apiFetch<Group>(`/groups/${groupId}`, {method: "DELETE"});
}
